<div appClickOutside class="editable-image-container" [ngClass]="customClass()"
    [isActive]="forceEditMode() || (showEditButton && isEditMode$())" (clickOutside)="onClickOutside()">

    @if(forceEditMode() || (showEditButton && isEditMode$())) {
    <div class="editable-actions admin-theme" [ngStyle]="{'top': topSpacing()}">

        <button mat-mini-fab (click)="openImageCropper($event)">
            <mat-icon>edit</mat-icon>
        </button>
        @if(isClickable()) {
        <button mat-mini-fab (click)="openInteraction($event)">
            <mat-icon>settings</mat-icon>
        </button>
        }
    </div>

    @if(isInteractionConfigOpen) {
    <app-button-actions [elemId]="elemId()" (closePanel)="closeAllConfig()">
    </app-button-actions>
    }
    }

    <div class="image-container" (click)="onClick()">
        <img [ngSrc]="imageSRC$()['url']" [alt]="altText$()" fill [priority]="hasPriority()"
        placeholder="/assets/placeholder-image.png" (load)="onImageLoad()" (error)="onImageError()" />
        @if(reloadingImage) {
            <div class="image-overlay admin-theme">
                <mat-spinner diameter="50"></mat-spinner>
            </div>
        }
    </div>
</div>